import { ProductSlider } from './ProductSlider'
import { useProductAttributes } from '../../../state'

export function RelatedProducts() {
  const { relatedProducts, loadingRelated } = useProductAttributes()

  return (
    <ProductSlider
      products={relatedProducts}
      loading={loadingRelated}
      title="Te-ar mai putea interesa"
    />
  )
}
